/**
 * Page path ("/fall-guide") → the dated campaign whose landing page it is,
 * matched by its address on this site (as CampaignEditor picks one).
 */
export function landingCampaigns(
  campaigns: Array<{ id: string; name: string; kind: string; landingPageUrl?: string | null }>,
  siteUrl: string | null
): Map<string, { id: string; name: string }> {
  const out = new Map<string, { id: string; name: string }>();
  const base = (siteUrl || '').replace(/\/+$/, '');
  if (!base) return out;
  for (const c of campaigns) {
    const url = c.landingPageUrl || '';
    if (c.kind === 'always_on' || !url.startsWith(base)) continue;
    const path =
      url
        .slice(base.length)
        .replace(/[?#].*$/, '')
        .replace(/(.)\/+$/, '$1') || '/';
    if (!out.has(path)) out.set(path, { id: c.id, name: c.name });
  }
  return out;
}
